import { render, staticRenderFns } from "./Uteleme.vue?vue&type=template&id=0e0c8494&"
import script from "./Uteleme.vue?vue&type=script&lang=js&"
export * from "./Uteleme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports